/**
 * @file useTriggerGroup
 */
import { TriggerGroup } from '@tencent/glue-model-popper';
import { useSingleton } from '@tencent/glue-react-use';
import { usePopperInstance } from '../context/Popper';
import { useTriggerGroupInstance } from '../context/TriggerGroup';
export function useTriggerGroup(triggerGroupId) {
  var popper = usePopperInstance();
  var triggerGroup = useTriggerGroupInstance();
  return useSingleton(function () {
    return new TriggerGroup(popper, triggerGroup, triggerGroupId);
  });
}